module.exports = __webpack_public_path__ + "img/hc_pro_ten_19.3797448e.jpg";